(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    const initNoTickerRotation = () => {
      const message = annBar?.querySelector(
        ".announcement-bar__message-no-ticker"
      );
      const text = message?.querySelector(".announcement-bar__text");
      text?.querySelector(".announcement-bar__loop-copy")?.remove();
      const items = text ? Array.from(text.children) : [];

      if (!message || !text || items.length < 2) return;

      message.noTickerRotationCleanup?.();

      const loopCopy = items[0].cloneNode(true);
      loopCopy.classList.add("announcement-bar__loop-copy");
      loopCopy.setAttribute("aria-hidden", "true");
      loopCopy.inert = true;
      text.append(loopCopy);

      const mobileQuery = window.matchMedia("(max-width: 767px)");
      let currentItem = 0;
      let rotationInterval;

      const showItem = (index, behavior = "smooth") => {
        text.scrollTo({
          left: items[index].offsetLeft,
          behavior,
        });
      };

      const stopRotation = () => {
        window.clearInterval(rotationInterval);
        rotationInterval = undefined;
      };

      const updateRotation = () => {
        stopRotation();

        if (!mobileQuery.matches) {
          currentItem = 0;
          showItem(currentItem, "auto");
          return;
        }

        rotationInterval = window.setInterval(() => {
          currentItem += 1;

          if (currentItem === items.length) {
            text.scrollTo({ left: loopCopy.offsetLeft, behavior: "smooth" });
            window.setTimeout(() => {
              currentItem = 0;
              showItem(currentItem, "auto");
            }, 600);
            return;
          }

          showItem(currentItem);
        }, 3000);
      };

      mobileQuery.addEventListener("change", updateRotation);
      message.noTickerRotationCleanup = () => {
        stopRotation();
        mobileQuery.removeEventListener("change", updateRotation);
        loopCopy.remove();
      };

      updateRotation();
    };

    let intersectionObserver;
    let resizeObserver;
    let lastRatio = 1;

    const updateHeight = (intersectionRatio = 1) => {
      const annBarHeight = annBar?.getBoundingClientRect().height || 0;
      const effectiveHeight = (annBarHeight * intersectionRatio).toFixed(2);
      document.documentElement.style.setProperty(
        "--ann-height",
        `${effectiveHeight}px`
      );
    };

    const createObservers = () => {
      if (intersectionObserver) intersectionObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updateHeight(entry.intersectionRatio);
              lastRatio = entry.intersectionRatio;
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
              lastRatio = 0;
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      resizeObserver = new ResizeObserver(() => {
        updateHeight(lastRatio);
      });

      if (annBar) intersectionObserver.observe(annBar);
      if (annBar) resizeObserver.observe(annBar);
    };

    createObservers();
    initNoTickerRotation();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
